<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      SuperAdmin Area
    </h1>
    <form @submit.prevent="submit">
      <div class="row mt-4">
        <h2>Upload Berkas Akhir Studi Mahasiswa</h2>
      </div>
      <div class="row mt-4">
        <file-input
          v-model="form.eos_payments_file"
          class="pr-6 pb-4 w-full lg:w-1/2"
          type="file"
          label="File .csv berkas akhir studi untuk di import:" />
      </div>
      <progress
        v-if="form.progress"
        :value="form.progress.percentage"
        max="100">
        {{ form.progress.percentage }}%
      </progress>
      <button
        :disabled="form.progress"
        class="flex items-center btn-indigo"
        title="Import data mahasiswa from AWS S3">
        <div v-if="form.progress" class="btn-spinner mr-2" />
        Upload dan Proses Data akhir studi
      </button>
    </form>
  </div>
</template>

<script lang="js">
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import { useForm } from '@inertiajs/vue2'

export default {
  metaInfo: { title: 'Config' },
  layout: Layout,

  data () {
    return {
      form: useForm({
        eos_payments_file: null,
      }),
    }
  },
  components: {
    FileInput,
  },
  methods: {
    submit () {
      this.form.post('/import/eosfile', {
        onSuccess: () => this.form.reset('eos_payments_file'),
      })
    },
  },
}
</script>
